module.exports = __webpack_public_path__ + "img/cover-arno.08f85dbb.png";